import { HttpParams } from '@angular/common/http';

export const HIDE_LOADER_HEADER = 'X-Hide-Loader';
export const HIDE_LOADER_HEADER_VALUE = 'true';

export class InterceptorHttpParams extends HttpParams {
  constructor(
    public interceptorConfig: { [key: string]: any },
    params?: { [param: string]: string | string[] }
  ) {
    super({fromObject: params});
  }
}

export const hideLoader = (hide = true) => new InterceptorHttpParams({hideLoader: hide});
export const rawResponse = (map = false) => new InterceptorHttpParams({mapResponse: map});
